import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { showModal } from "../../../reducers/modal/modal.actions";
import { updatePenyelenggara } from "../../../reducers/monev/monev.actions";
import { fieldErrorMessage, fieldHasErrors } from "../../../store/errorHandler";
import { PermissionMenuName } from "../../../interfaces/UserRole";
import { allowSave } from "../../../store/helpers";

export const FormPenyelenggara = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state: RootState) => state.monev.error);
  const isLoading = useSelector((state: RootState) => state.monev.isLoading);
  const penyelenggara = useSelector((state: RootState) => state.monev.selectedMonev?.PENYELENGGARA_DETAIL);
  const penyelenggaraPartner  = useSelector((state: RootState) => state.monev.selectedDokumenKerjasama?.CO_DETAIL);
  const penyelenggaraDepartment  = useSelector((state: RootState) => state.monev.selectedDokumenKerjasama?.PELAKSANA_KERJASAMA);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.monevPartner].ACCESS);

  const [txtPenyelenggara, setTxtPenyelenggara] = useState<string>("");

  const canSave = allowSave(role, 3);

  const addPenyelenggara = () => {
    if (typeof penyelenggara === 'undefined') return;
    if (!txtPenyelenggara.trim()) {
      dispatch(showModal('Penyelenggara tidak boleh kosong!', 'Mohon masukkan nama penyelenggara terlebih dahulu.'));
      return;
    }
    const newPenyelenggara = [...penyelenggara];
    newPenyelenggara.push({ NAME: txtPenyelenggara });
    setTxtPenyelenggara("");
    dispatch(updatePenyelenggara(newPenyelenggara));
  }

  const addPenyelenggaraUmn = () => {
    if (typeof penyelenggara === 'undefined') return;
    const newPenyelenggara = [...penyelenggara];

    if (!newPenyelenggara.find(search => search.NAME === 'Universitas Multimedia Nusantara')) {
      newPenyelenggara.push({ NAME: 'Universitas Multimedia Nusantara' });
    } else {
      dispatch(showModal(
        'Tidak ada perubahan yang dibuat.',
        'UMN telah terdaftar sebagai penyelenggara.'
      ));
      return;
    }

    dispatch(updatePenyelenggara(newPenyelenggara));
  }

  const addPenyelenggaraDepartment = () => {
    if (typeof penyelenggara === 'undefined') return;
    const newPenyelenggara = [...penyelenggara];

    if (penyelenggaraDepartment?.length === 0) {
      dispatch(showModal(
        'Gagal menambahkan penyelenggara dari UMN',
        'Dokumen kerjasama tidak memuat data department UMN. Mohon menambahkan pelaksana kerjasama terlebih dahulu pada dokumen terkait.'
      ));
      return;
    }

    let itemsAdded = 0;
    penyelenggaraDepartment?.forEach(item => {
      if (!newPenyelenggara.find(search => search.NAME === item.DEPT_NAME)) {
        newPenyelenggara.push({ NAME: item.DEPT_NAME });
        itemsAdded++;
      }
    })

    if (itemsAdded === 0) {
      dispatch(showModal(
        'Tidak ada penyelenggara yang ditambahkan',
        'Sepertinya penyelenggara yang terdaftar di dokumen kerjasama sudah terdaftar pada kegiatan.'
      ));
      return;  
    }

    dispatch(updatePenyelenggara(newPenyelenggara));
  }

  const addPenyelenggaraPartner = () => {
    if (typeof penyelenggara === 'undefined') return;
    const newPenyelenggara = [...penyelenggara];

    if (penyelenggaraPartner?.length === 0) {
      dispatch(showModal(
        'Gagal menambahkan penyelenggara dari partner',
        'Dokumen kerjasama tidak memuat data partner. Mohon menambahkan partner terlebih dahulu pada dokumen terkait.'
      ));
      return;
    }

    let itemsAdded = 0;
    penyelenggaraPartner?.forEach(item => {
      if (!newPenyelenggara.find(search => search.NAME === item.CO_NAME)) {
        newPenyelenggara.push({ NAME: item.CO_NAME });
        itemsAdded++;
      }
    })

    if (itemsAdded === 0) {
      dispatch(showModal(
        'Tidak ada penyelenggara yang ditambahkan',
        'Sepertinya penyelenggara yang terdaftar di dokumen kerjasama sudah terdaftar pada kegiatan.'
      ));
      return;  
    }

    dispatch(updatePenyelenggara(newPenyelenggara));
  }

  const removePenyelenggara = (id: number) => {
    if (typeof penyelenggara === 'undefined') return;
    const newPenyelenggara = [...penyelenggara];
    newPenyelenggara.splice(id, 1);
    dispatch(updatePenyelenggara(newPenyelenggara));
  }

  const onTxtPenyelenggaraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTxtPenyelenggara(e.target.value);
  }

  const renderPenyelenggara = () => {
    if (penyelenggara?.length === 0) {
      return (
        <tr>
          <td colSpan={2} style={{textAlign: 'center'}}>
            Data tidak ditemukan, silahkan tambah penyelenggara baru.
          </td>
        </tr>
      );
    }

    return penyelenggara?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.NAME}</td>
          <th>
            <button className="btn btn-danger btn-xs" disabled={isLoading || !canSave} onClick={() => removePenyelenggara(index)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      );
    });
  }

  if (typeof penyelenggaraDepartment == 'undefined' || typeof penyelenggaraPartner == 'undefined' || typeof penyelenggara == 'undefined') return (
    <React.Fragment>
      <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Penyelenggara Kegiatan</h3>
          </div>
        <div className="box-body">
          Sedang memuat data...
        </div>
        <div className="overlay active">
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Penyelenggara Kegiatan</h3>
        </div>
        <div className="box-body">
          
          <div className={`form-group ${fieldHasErrors('PENYELENGGARA', errors) ? 'has-error' : ''}`}>
            <label>Tambah Penyelenggara<span className="text-red"><b>*</b></span></label>
            <div className="input-group">
              <input
                type="text"
                disabled={isLoading || !canSave}
                className="form-control"
                value={txtPenyelenggara}
                onChange={onTxtPenyelenggaraChange}
                placeholder="Masukan nama penyelenggara"
              />
              <span className="input-group-btn">
                <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={() => addPenyelenggara()}>
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <span className="help-block">{ fieldErrorMessage('PENYELENGGARA', errors) }</span>
          </div>
          
          <div style={{ marginTop: 5 }}>
            <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={() => addPenyelenggaraUmn()}>
              UMN
            </button>
            &nbsp;
            <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={() => addPenyelenggaraDepartment()}>
              Departemen
            </button>
            &nbsp;
            <button type="button" className="btn btn-primary" disabled={isLoading || !canSave} onClick={() => addPenyelenggaraPartner()}>
              Partner
            </button>
          </div>
        </div>
        <div className="box-body table-responsive no-padding" style={{ maxHeight: '200px' }}>
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="sticky">Penyelenggara</th>
                <th className="sticky"></th>
              </tr>
            </thead>
            <tbody>
              {renderPenyelenggara()}
            </tbody>
          </table>
        </div>
        <div className={`overlay ${isLoading ? 'active' : null}`}>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      </div>
    </React.Fragment>
  );
};
